import JobCategories from './JobCategories';
import Recruiters from './Recruiters';
import CityPages from './CityPages';
import {Sitemap} from './types';
import {Box} from '@mui/material';
import Blogs from './Blogs';
import Companies from './Companies';

const HTMLSitemap = ({categories}: Sitemap) => {
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  return (
    <Box
      sx={{
        marginTop: isAppIimjobs ? '0px' : '50px',
        mx: isAppIimjobs ? 0 : 2,
      }}
    >
      <JobCategories categories={categories} />
      {!isAppIimjobs && <Companies />}
      <Recruiters />
      {isAppIimjobs && <CityPages />}
      {!isAppIimjobs && <Blogs />}
    </Box>
  );
};

export default HTMLSitemap;
